export default __webpack_public_path__ + "static/2-7dfd172ba5547c1e1bd67183cb8aeebb.jpeg";